import { render, staticRenderFns } from "./trainingpractical.vue?vue&type=template&id=1378c6d4&scoped=true"
import script from "./trainingpractical.vue?vue&type=script&lang=js"
export * from "./trainingpractical.vue?vue&type=script&lang=js"
import style0 from "./trainingpractical.vue?vue&type=style&index=0&id=1378c6d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1378c6d4",
  null
  
)

export default component.exports